import React from 'react';
import PropTypes from 'prop-types';

import { FieldConnect } from 'react-components-form';

import './SelectField.scss';
import { i18n } from "../../../config";
import Loader from '../../Loader/Loader';
import ErrorField from '../ErrorField/ErrorField';

export const SelectField = ({
    wrapperClassName,
    className,
    onChange,
    name,
    validationErrors,
    hasValidationError,
    options = [],
    value,
    label,
    placeholder,
    errorStyles,
    fieldAttributes,
    required,
    onChangeValue,
    emptyOption,
    selectOption,
    loading,
    donotSort
}) => {
     let sortedOptions = options;
    // Keep option with value "" at the top, sort the rest alphabetically by label
    if(!donotSort || donotSort == undefined){
        const emptyValueOption = options.find(opt => (opt.value !== undefined ? opt.value === "" : (opt === "" || opt === i18n.t('common:fields.select'))));
        const otherOptions = options.filter(opt => (opt.value !== undefined ? opt.value !== "" : (opt !== "" && opt !== i18n.t('common:fields.select'))));

        sortedOptions = [
            ...(emptyValueOption ? [emptyValueOption] : []),
            ...otherOptions.sort((a, b) => {
                const aLabel = ( a.label || a.value ) ? (typeof a.label === 'string' ? a.label : a.value.toString()) : a.toString();
                const bLabel = ( b.label || b.value ) ? (typeof b.label === 'string' ? b.label : b.value.toString()) : b.toString();
                if (aLabel && bLabel) {
                    return aLabel.localeCompare(bLabel,'et');
                }
                return 0;
            })
        ];
    }

    return (
        <div className={hasValidationError === true ? 'mb-3' : 'mb-3'}>
            {label && (
                <label htmlFor={name}>
                    {loading && <Loader></Loader>}
                    {label}
                    {required && <span className="text-danger"> *</span>}
                </label>
            )}
            <select
                name={name}
                onChange={e => {
                    onChange(e.target.value);
                    if (onChangeValue) onChangeValue(e.target.value);
                }}
                value={value}
                placeholder={placeholder}
                className={hasValidationError ? 'form-select is-invalid' : 'form-select'}
                {...fieldAttributes}
            >
                {emptyOption &&
                    <option
                        value={0}
                        key={0}
                        disabled={options.disabled}
                    />
                }

                {selectOption &&
                    <option
                        value={""}
                        key={0}
                        disabled={options.disabled}
                    >
                        {i18n.t('common:fields.select')}
                    </option>
                }

                {sortedOptions.map(option => (
                    <option
                        value={option.value !== undefined ? option.value : option}
                        key={option.value !== undefined ? option.value : option}
                        disabled={option.disabled}
                    >
                        {typeof option === 'object' ? option.label : option}
                    </option>
                ))}
            </select>

            {hasValidationError &&
                <small className="text-form text-danger">
                    <ErrorField errors={validationErrors} {...errorStyles} />
                </small>}
        </div>
    );
}

SelectField.propTypes = {
    options: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({}),
    ])),
    onChangeValue: PropTypes.func
};

export default FieldConnect(SelectField);
